import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { Menu } from 'antd';
import IconSvg from '../common/IconSvg';
import { themeColors } from '../../constants/themes';

export const SanityCheckContainer = props => {
  return (
    <div
      css={css`
        padding: 0;
        height: 68px;
        background: #fff;
        border-bottom: solid #e9eaef 1px;
        position: relative;
        box-shadow: 0px 6px 7px rgba(0, 105, 250, 0.17);
        z-index: 1;
        max-height: 0;
        opacity: 0;
        transition: max-height 0.2s ease-out 0.2s, opacity 0.2s linear;
        ${!props.open &&
          props.mobileLayout &&
          `
          display: none;
        `}
        ${props.open &&
          `
          max-height: 68px;
          opacity: 1;
          transition: max-height 0.2s ease-out,opacity 0.2s linear 0.2s;
        `}
        ${props.mobileLayout && `min-height: 320px; max-height:320px !important; top: 285px; `}
      `}
    >
      {props.children}
      <span
        css={css`
          padding: 0 0.5em;
          cursor: pointer;
          position: absolute;
          top: 0;
          right: 0;
          ${!props.open &&
            `
            display: none;
          `}
        `}
        onClick={props.toggleSanityCheck}
      >
        <IconSvg size={10} type="exit" hoverColor={themeColors.blue} />
      </span>
    </div>
  );
};

export const StyledMenuItem = styled(Menu.Item)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  cursor: default;
  flex-direction: column;
`;

export const SanityCheckTitle = styled('div')`
  font-size: 12px;
  line-height: 13px;
  font-family: 'Heebo';
  margin-top: ${({ textMargin }) => textMargin || '1em'};
`;

export const SanityCheckEntry = props => {
  return (
    <React.Fragment>
      <IconSvg type={props.icon} size={props.size} />
      <SanityCheckTitle textMargin={props.textMargin}>{props.title}</SanityCheckTitle>
    </React.Fragment>
  );
};
